module.exports = __webpack_public_path__ + "media/img/gatuno-57826912.png";